// Static Steps / Pages / Views the FW can show
var STEP_START = 'STEP_START';
var STEP_CALCULATION = 'STEP_CALCULATION';
var STEP_USER_DATA = 'STEP_USER_DATA';

// Possible field types
var FIELD_TYPE_CHOICE = 'choice';
var FIELD_TYPE_ADDRESS = 'address';
var FIELD_TYPE_POSTAL = 'postal_code';
var FIELD_TYPE_NUMERICAL = 'numerical';
var FIELD_TYPE_TEXT = 'text';

// Possible variants
var VARIANTS = {
  DEFAULT: 'default',
  HIGHLIGHTED: 'highlighted',
  CLEAN: 'clean',
  CTA: 'cta',
  CTA2: 'cta2',
  EXTENDED: 'extended',
  RAFFLE: 'raffle'
};
export { FIELD_TYPE_ADDRESS, FIELD_TYPE_CHOICE, FIELD_TYPE_NUMERICAL, FIELD_TYPE_POSTAL, FIELD_TYPE_TEXT, STEP_CALCULATION, STEP_START, STEP_USER_DATA, VARIANTS };